/* ===================================================================
   SharkFoto Free Tools — master tool registry
   Each tool is its own page. To add one: drop a line into the right
   category/operation array with { name, badge }.
   =================================================================== */
export const CATEGORIES=[
  {
    key:'image', label:"Image Tools", color:'#ff6f9c',
    sub:"Convert, shrink and edit photos — JPG, PNG, WEBP, HEIC, SVG and more.",
    tools:{
      convert:[
        {name:"Image Converter", badge:"Any → JPG/PNG/WEBP", href:"Image Converter.html"},
        {name:"WEBP to PNG", badge:"Lossless", href:"WEBP to PNG.html"},
        {name:"WEBP to JPG", badge:"Smaller files", href:"WEBP to JPG.html"},
        {name:"HEIC to JPG", badge:"iPhone photos", href:"HEIC to JPG.html"},
        {name:"HEIC to PNG", badge:"Transparent", href:"HEIC to PNG.html"},
        {name:"JFIF to PNG", badge:"Fix odd files", href:"JFIF to PNG.html"},
        {name:"PNG to SVG", badge:"Vectorize", href:"PNG to SVG.html"},
        {name:"SVG Converter", badge:"Rasterize", href:"SVG Converter.html"},
        {name:"PNG to ICO", badge:"Favicons", href:"PNG to ICO.html"},
        {name:"ICO to PNG", badge:"Extract icon", href:"ICO to PNG.html"},
        {name:"AVIF to PNG", badge:"Next-gen → PNG", href:"AVIF to PNG.html"},
        {name:"AVIF to JPG", badge:"Next-gen → JPG", href:"AVIF to JPG.html"},
        {name:"PNG to AVIF", badge:"Smaller files", href:"PNG to AVIF.html"},
        {name:"JPG to CMYK", badge:"Print color", href:"JPG to CMYK.html"},
        {name:"PNG to CMYK", badge:"Print color", href:"PNG to CMYK.html"},
        {name:"JPEG to CMYK", badge:"Print color", href:"JPEG to CMYK.html"},
        {name:"SVG to CMYK", badge:"Print color", href:"SVG to CMYK.html"}
      ],
      compress:[
        {name:"Image Compressor", badge:"Up to 90% smaller", href:"Image Compressor.html"},
        {name:"JPEG Compressor", badge:"Quality control", href:"JPEG Compressor.html"},
        {name:"PNG Compressor", badge:"Keep alpha", href:"PNG Compressor.html"}
      ],
      edit:[
        {name:"Resize Image", badge:"Exact dimensions", href:"Resize Image.html"},
        {name:"Crop Image", badge:"Free or ratio", href:"Crop Image.html"},
        {name:"Rotate Image", badge:"90° / any angle", href:"Rotate Image.html"},
        {name:"Flip Image", badge:"Mirror H / V", href:"Flip Image.html"},
        {name:"Image Enlarger", badge:"Upscale 2×", href:"Image Enlarger.html"},
        {name:"Add Watermark to Image", badge:"Text or logo", href:"Add Watermark to Image.html"},
        {name:"Round Image Corners", badge:"Rounded edges", href:"Round Image Corners.html"},
        {name:"Add Border to Image", badge:"Frame & color", href:"Add Border to Image.html"},
        {name:"Meme Generator", badge:"Top & bottom text", href:"Meme Generator.html"},
        {name:"Black & White Image", badge:"Grayscale & duotone", href:"Black and White Image.html"},
        {name:"Brightness & Contrast", badge:"Tone adjust", href:"Brightness and Contrast.html"},
        {name:"Photo Collage", badge:"Grid layouts", href:"Photo Collage.html"},
        {name:"EXIF Viewer", badge:"Read metadata", href:"EXIF Viewer.html"},
        {name:"EXIF Remover", badge:"Strip metadata", href:"EXIF Remover.html"},
        {name:"Image to ASCII", badge:"Text art", href:"Image to ASCII.html"},
        {name:"Image to Base64", badge:"Data URI", href:"Image to Base64.html"},
        {name:"Image to Grayscale", badge:"Black & white", href:"Image to Grayscale.html"},
        {name:"Color Picker", badge:"Pick from image", href:"Color Picker.html"}
      ]
    }
  },
  {
    key:'camera', label:"Camera Raw", color:'#e0a32e',
    sub:"Convert camera raw photos — DNG, CR2, CR3, ARW, NEF and more.",
    tools:{
      convert:[
        {name:"XMP to DNG", badge:"Bake in edits", href:"XMP to DNG.html"},
        {name:"JPG to DNG", badge:"Raw container", href:"JPG to DNG.html"},
        {name:"PNG to DNG", badge:"Raw container", href:"PNG to DNG.html"},
        {name:"JPEG to DNG", badge:"Raw container", href:"JPEG to DNG.html"},
        {name:"HEIC to DNG", badge:"iPhone raw", href:"HEIC to DNG.html"},
        {name:"TIFF to DNG", badge:"Raw container", href:"TIFF to DNG.html"},
        {name:"JPG to CR2", badge:"Canon raw", href:"JPG to CR2.html"},
        {name:"JPG to CR3", badge:"Canon raw", href:"JPG to CR3.html"},
        {name:"JPG to ARW", badge:"Sony raw", href:"JPG to ARW.html"},
        {name:"JPG to NEF", badge:"Nikon raw", href:"JPG to NEF.html"},
        {name:"JPG to RAF", badge:"Fuji raw", href:"JPG to RAF.html"},
        {name:"JPG to RAW", badge:"Sensor data", href:"JPG to RAW.html"},
        {name:"CR3 to CR2", badge:"Canon raw", href:"CR3 to CR2.html"},
        {name:"CR3 to RAW", badge:"Canon raw", href:"CR3 to RAW.html"},
        {name:"ARW to DNG", badge:"Sony → DNG", href:"ARW to DNG.html"},
        {name:"ARW to CR2", badge:"Sony → Canon", href:"ARW to CR2.html"},
        {name:"NEF to RAW", badge:"Nikon raw", href:"NEF to RAW.html"},
        {name:"RW2 to DNG", badge:"Panasonic → DNG", href:"RW2 to DNG.html"},
        {name:"TIFF to RAW", badge:"Sensor data", href:"TIFF to RAW.html"},
        {name:"HEIC to RAW", badge:"iPhone raw", href:"HEIC to RAW.html"},
        {name:"HEIF to RAW", badge:"HEIF raw", href:"HEIF to RAW.html"},
        {name:"WEBP to RAW", badge:"Sensor data", href:"WEBP to RAW.html"},
        {name:"BMP to RAW", badge:"Sensor data", href:"BMP to RAW.html"},
        {name:"THM to JPG", badge:"Thumbnail → JPG", href:"THM to JPG.html"},
        {name:"THM to PNG", badge:"Thumbnail → PNG", href:"THM to PNG.html"},
        {name:"ITHMB to JPG", badge:"Apple cache", href:"ITHMB to JPG.html"},
        {name:"DNG to CR2", badge:"DNG → Canon", href:"DNG to CR2.html"},
        {name:"DNG to HEIC", badge:"DNG → iPhone", href:"DNG to HEIC.html"}
      ],
      compress:[],
      edit:[]
    }
  },
  {
    key:'video', label:"Video Tools", color:'#4ea2ff',
    sub:"Change formats, shrink size and make quick edits to your clips.",
    tools:{
      convert:[
        {name:"Video Converter", badge:"MP4, MOV, WEBM", href:"Video Converter.html"},
        {name:"MOV to MP4", badge:"Universal play", href:"MOV to MP4.html"},
        {name:"MP4 Converter", badge:"Any → MP4", href:"MP4 Converter.html"},
        {name:"Video to MP3", badge:"Extract audio", href:"Video to MP3.html"}
      ],
      compress:[
        {name:"Video Compressor", badge:"Email-ready size", href:"Video Compressor.html"}
      ],
      edit:[
        {name:"Trim Video", badge:"Cut start / end", href:"Trim Video.html"},
        {name:"Crop Video", badge:"Reframe", href:"Crop Video.html"},
        {name:"Resize Video", badge:"Change resolution", href:"Resize Video.html"},
        {name:"Change Video Speed", badge:"0.25× – 4×", href:"Change Video Speed.html"},
        {name:"Reverse Video", badge:"Play backwards", href:"Reverse Video.html"},
        {name:"Mute Video", badge:"Remove audio", href:"Mute Video.html"},
        {name:"Merge Videos", badge:"Join clips", href:"Merge Videos.html"},
        {name:"Extract Video Frames", badge:"Video → images", href:"Extract Video Frames.html"},
        {name:"Add Subtitles to Video", badge:"Captions", href:"Add Subtitles to Video.html"}
      ]
    }
  },
  {
    key:'gif', label:"GIF Tools", color:'#34d399',
    sub:"Make and convert animated GIFs from video, images or other formats.",
    tools:{
      convert:[
        {name:"Video to GIF", badge:"Clip → loop", href:"Video to GIF.html"},
        {name:"MP4 to GIF", badge:"Popular", href:"MP4 to GIF.html"},
        {name:"WEBM to GIF", badge:"Web video", href:"WEBM to GIF.html"},
        {name:"GIF to MP4", badge:"Smaller share", href:"GIF to MP4.html"},
        {name:"Image to GIF", badge:"Slideshow", href:"Image to GIF.html"},
        {name:"APNG to GIF", badge:"Animated PNG", href:"APNG to GIF.html"}
      ],
      compress:[
        {name:"GIF Compressor", badge:"Trim frames", href:"GIF Compressor.html"}
      ],
      edit:[
        {name:"GIF Maker", badge:"Frames → GIF", href:"GIF Maker.html"}
      ]
    }
  },
  {
    key:'audio', label:"Audio Tools", color:'#22d3ee',
    sub:"Convert and compress audio — MP3, WAV, OGG and more.",
    tools:{
      convert:[
        {name:"Audio Converter", badge:"MP3, WAV, OGG", href:"Audio Converter.html"},
        {name:"MP4 to MP3", badge:"Rip audio", href:"MP4 to MP3.html"},
        {name:"MP3 to OGG", badge:"Open format", href:"MP3 to OGG.html"}
      ],
      compress:[
        {name:"MP3 Compressor", badge:"Lower bitrate", href:"MP3 Compressor.html"},
        {name:"WAV Compressor", badge:"Shrink lossless", href:"WAV Compressor.html"}
      ],
      edit:[
        {name:"Audio Trimmer", badge:"Cut start / end", href:"Audio Trimmer.html"},
        {name:"Merge Audio", badge:"Join tracks", href:"Merge Audio.html"},
        {name:"Change Audio Speed", badge:"0.5× – 2×", href:"Change Audio Speed.html"},
        {name:"Audio Fade In/Out", badge:"Smooth start/end", href:"Audio Fade.html"},
        {name:"Ringtone Maker", badge:"30s ringtones", href:"Ringtone Maker.html"},
        {name:"Voice Recorder", badge:"Record & download", href:"Voice Recorder.html"}
      ]
    }
  },
  {
    key:'generate', label:"Generators", color:'#a78bfa',
    sub:"Create QR codes and barcodes — free, instant, right in your browser.",
    tools:{
      convert:[],
      compress:[],
      edit:[
        {name:"QR Code Generator", badge:"URL, text, WiFi", href:"QR Code Generator.html"},
        {name:"Barcode Generator", badge:"EAN, UPC, Code128", href:"Barcode Generator.html"}
      ]
    }
  },
  {
    key:'design', label:"Design Utilities", color:'#f97316',
    sub:"Handy color and layout helpers for designers and developers.",
    tools:{
      convert:[],
      compress:[],
      edit:[
        {name:"Color Palette Generator", badge:"Build & export", href:"Color Palette Generator.html"},
        {name:"Contrast Checker", badge:"WCAG AA / AAA", href:"Contrast Checker.html"},
        {name:"Gradient Generator", badge:"CSS gradients", href:"Gradient Generator.html"},
        {name:"RGB to CMYK Converter", badge:"Color values", href:"RGB to CMYK Converter.html"},
        {name:"CMYK to RGB Converter", badge:"Color values", href:"CMYK to RGB Converter.html"},
        {name:"Grayscale to RGB Converter", badge:"Color values", href:"Grayscale to RGB Converter.html"},
        {name:"Social Media Image Sizes", badge:"2026 cheat sheet", href:"Social Media Image Sizes.html"}
      ]
    }
  },
  {
    key:'ai', label:"AI Tools", color:'#8b5cf6',
    sub:"AI-powered background removal, upscaling and enhancement — by format.",
    tools:{
      convert:[],
      compress:[],
      edit:[
        {name:"AVIF Background Remover", badge:"AI · one tap", href:"AVIF Background Remover.html"},
        {name:"GIF Background Remover", badge:"AI · one tap", href:"GIF Background Remover.html"},
        {name:"SVG Background Remover", badge:"AI · one tap", href:"SVG Background Remover.html"},
        {name:"ICO Background Remover", badge:"AI · one tap", href:"ICO Background Remover.html"},
        {name:"WEBP Background Remover", badge:"AI · one tap", href:"WEBP Background Remover.html"},
        {name:"TIFF Background Remover", badge:"AI · one tap", href:"TIFF Background Remover.html"},
        {name:"BMP Background Remover", badge:"AI · one tap", href:"BMP Background Remover.html"},
        {name:"PSD Background Remover", badge:"AI · one tap", href:"PSD Background Remover.html"},
        {name:"GIF Image Enhancer", badge:"Per-frame HD", href:"GIF Image Enhancer.html"},
        {name:"TIFF Image Enhancer", badge:"Photo · 4K", href:"TIFF Image Enhancer.html"},
        {name:"AVIF Image Enhancer", badge:"Photo · 4K", href:"AVIF Image Enhancer.html"},
        {name:"DDS Image Enhancer", badge:"Photo · 4K", href:"DDS Image Enhancer.html"},
        {name:"ICO Image Enhancer", badge:"Icon → HD", href:"ICO Image Enhancer.html"},
        {name:"SVG Image Enhancer", badge:"Vector → HD", href:"SVG Image Enhancer.html"},
        {name:"JFIF Image Enhancer", badge:"Photo · 4K", href:"JFIF Image Enhancer.html"},
        {name:"PSD Image Enhancer", badge:"Layered · 4K", href:"PSD Image Enhancer.html"},
        {name:"HEIC Image Enhancer", badge:"Photo · 4K", href:"HEIC Image Enhancer.html"},
        {name:"CR2 Image Enhancer", badge:"RAW · 4K", href:"CR2 Image Enhancer.html"},
        {name:"CDR Image Enhancer", badge:"Vector → HD", href:"CDR Image Enhancer.html"},
        {name:"EPS Image Enhancer", badge:"Vector → HD", href:"EPS Image Enhancer.html"},
        {name:"HEIF Image Enhancer", badge:"Photo · 4K", href:"HEIF Image Enhancer.html"},
        {name:"NEF Image Enhancer", badge:"RAW · 4K", href:"NEF Image Enhancer.html"},
        {name:"CMYK Image Enhancer", badge:"Print · 4K", href:"CMYK Image Enhancer.html"},
        {name:"DNG Image Enhancer", badge:"RAW · 4K", href:"DNG Image Enhancer.html"},
        {name:"TGA Image Enhancer", badge:"Photo · 4K", href:"TGA Image Enhancer.html"},
        {name:"BMP Image Enhancer", badge:"Photo · 4K", href:"BMP Image Enhancer.html"},
        {name:"EXR Image Enhancer", badge:"HDR → 4K", href:"EXR Image Enhancer.html"},
        {name:"PNG Image Enhancer", badge:"Photo · 4K", href:"PNG Image Enhancer.html"},
        {name:"CR3 Image Enhancer", badge:"RAW · 4K", href:"CR3 Image Enhancer.html"},
        {name:"MAP Image Enhancer", badge:"Vector → HD", href:"MAP Image Enhancer.html"},
        {name:"DWG Image Enhancer", badge:"Vector → HD", href:"DWG Image Enhancer.html"},
        {name:"DXF Image Enhancer", badge:"Vector → HD", href:"DXF Image Enhancer.html"},
        {name:"APNG Image Enhancer", badge:"Per-frame HD", href:"APNG Image Enhancer.html"},
        {name:"WEBP Image Enhancer", badge:"Photo · 4K", href:"WEBP Image Enhancer.html"},
        {name:"JBG Image Enhancer", badge:"Photo · 4K", href:"JBG Image Enhancer.html"},
        {name:"EMF Image Enhancer", badge:"Vector → HD", href:"EMF Image Enhancer.html"},
        {name:"ARW Image Enhancer", badge:"RAW · 4K", href:"ARW Image Enhancer.html"},
        {name:"XCF Image Enhancer", badge:"Layered · 4K", href:"XCF Image Enhancer.html"},
        {name:"HDR Image Enhancer", badge:"HDR → 4K", href:"HDR Image Enhancer.html"},
        {name:"PS3 Image Enhancer", badge:"Photo · 4K", href:"PS3 Image Enhancer.html"},
        {name:"Image Upscaler", badge:"AI · up to 4K", href:"https://sharkfoto.com/ai/image/image-upscaler/"}
      ]
    }
  },
  {
    key:'vector', label:"Vector & CAD", color:'#16a39c',
    sub:"Convert to and from vector and CAD formats — CDR, DXF, DWG and more.",
    tools:{
      convert:[
        {name:"JPG to CDR", badge:"CorelDRAW", href:"JPG to CDR.html"},
        {name:"PNG to CDR", badge:"CorelDRAW", href:"PNG to CDR.html"},
        {name:"JPEG to CDR", badge:"CorelDRAW", href:"JPEG to CDR.html"},
        {name:"Image to CDR", badge:"CorelDRAW", href:"Image to CDR.html"},
        {name:"SVG to CDR", badge:"Vector → Corel", href:"SVG to CDR.html"},
        {name:"PSD to CDR", badge:"Photoshop → Corel", href:"PSD to CDR.html"},
        {name:"EPS to CDR", badge:"Vector → Corel", href:"EPS to CDR.html"},
        {name:"AI to CDR", badge:"Illustrator → Corel", href:"AI to CDR.html"},
        {name:"TIFF to CDR", badge:"Image → Corel", href:"TIFF to CDR.html"},
        {name:"DXF to CDR", badge:"CAD → Corel", href:"DXF to CDR.html"},
        {name:"DWG to CDR", badge:"CAD → Corel", href:"DWG to CDR.html"},
        {name:"PDF to CDR", badge:"PDF → Corel", href:"PDF to CDR.html"}
      ],
      compress:[],
      edit:[]
    }
  },
  {
    key:'embroidery', label:"Embroidery", color:'#c2548a',
    sub:"Digitise images into machine-embroidery formats — DST, PES, EXP.",
    tools:{
      convert:[
        {name:"PNG to DST", badge:"Tajima", href:"PNG to DST.html"},
        {name:"JPG to DST", badge:"Tajima", href:"JPG to DST.html"},
        {name:"SVG to DST", badge:"Vector → stitches", href:"SVG to DST.html"},
        {name:"JPEG to DST", badge:"Tajima", href:"JPEG to DST.html"},
        {name:"Image to DST", badge:"Tajima", href:"Image to DST.html"},
        {name:"EPS to DST", badge:"Vector → stitches", href:"EPS to DST.html"},
        {name:"AI to DST", badge:"Vector → stitches", href:"AI to DST.html"},
        {name:"PNG to PES", badge:"Brother", href:"PNG to PES.html"},
        {name:"JPG to PES", badge:"Brother", href:"JPG to PES.html"},
        {name:"SVG to PES", badge:"Vector → stitches", href:"SVG to PES.html"},
        {name:"JPEG to PES", badge:"Brother", href:"JPEG to PES.html"},
        {name:"Image to PES", badge:"Brother", href:"Image to PES.html"},
        {name:"EPS to PES", badge:"Vector → stitches", href:"EPS to PES.html"},
        {name:"AI to PES", badge:"Vector → stitches", href:"AI to PES.html"},
        {name:"PES to DST", badge:"Brother → Tajima", href:"PES to DST.html"},
        {name:"DST to PES", badge:"Tajima → Brother", href:"DST to PES.html"},
        {name:"PNG to EXP", badge:"Melco", href:"PNG to EXP.html"},
        {name:"JPG to EXP", badge:"Melco", href:"JPG to EXP.html"}
      ],
      compress:[],
      edit:[]
    }
  },
  {
    key:'icon', label:"Icons & Data", color:'#5b8def',
    sub:"macOS icons (ICNS) and Apple property-list (PLIST) conversions.",
    tools:{
      convert:[
        {name:"SVG to ICNS", badge:"macOS icon", href:"SVG to ICNS.html"},
        {name:"ICO to ICNS", badge:"Windows → Mac", href:"ICO to ICNS.html"},
        {name:"PNG to ICNS", badge:"macOS icon", href:"PNG to ICNS.html"},
        {name:"JPG to ICNS", badge:"macOS icon", href:"JPG to ICNS.html"},
        {name:"JPEG to ICNS", badge:"macOS icon", href:"JPEG to ICNS.html"},
        {name:"ICNS to PNG", badge:"Mac → PNG", href:"ICNS to PNG.html"},
        {name:"ICNS to ICO", badge:"Mac → Windows", href:"ICNS to ICO.html"},
        {name:"ICNS to SVG", badge:"Mac → vector", href:"ICNS to SVG.html"},
        {name:"PNG to PLIST", badge:"Sprite atlas", href:"PNG to PLIST.html"},
        {name:"PLIST to PNG", badge:"Atlas → PNG", href:"PLIST to PNG.html"},
        {name:"PLIST to JPG", badge:"Atlas → JPG", href:"PLIST to JPG.html"}
      ],
      compress:[],
      edit:[]
    }
  },
  {
    key:'cad', label:"CAD & Diagrams", color:'#8a8f98',
    sub:"Trace images into CAD linework and diagrams — DWG, DXF, PLT, Visio.",
    tools:{
      convert:[
        {name:"PNG to DWG", badge:"AutoCAD", href:"PNG to DWG.html"},
        {name:"JPG to DWG", badge:"AutoCAD", href:"JPG to DWG.html"},
        {name:"JPEG to DWG", badge:"AutoCAD", href:"JPEG to DWG.html"},
        {name:"SVG to DWG", badge:"Vector → CAD", href:"SVG to DWG.html"},
        {name:"PNG to DXF", badge:"CAD exchange", href:"PNG to DXF.html"},
        {name:"JPG to DXF", badge:"CAD exchange", href:"JPG to DXF.html"},
        {name:"JPEG to DXF", badge:"CAD exchange", href:"JPEG to DXF.html"},
        {name:"Image to DXF", badge:"CAD exchange", href:"Image to DXF.html"},
        {name:"JPG to PLT", badge:"Plotter/cutter", href:"JPG to PLT.html"},
        {name:"PNG to PLT", badge:"Plotter/cutter", href:"PNG to PLT.html"},
        {name:"Image to PLT", badge:"Plotter/cutter", href:"Image to PLT.html"},
        {name:"PNG to Visio", badge:"VSDX diagram", href:"PNG to Visio.html"},
        {name:"JPG to Visio", badge:"VSDX diagram", href:"JPG to Visio.html"},
        {name:"Image to Visio", badge:"VSDX diagram", href:"Image to Visio.html"},
        {name:"PNG to VSDX", badge:"Visio", href:"PNG to VSDX.html"},
        {name:"DWG to Visio", badge:"CAD → Visio", href:"DWG to Visio.html"}
      ],
      compress:[],
      edit:[]
    }
  },
  {
    key:'misc', label:"More Converters", color:'#9c6ade',
    sub:"Handy extra format conversions — JXR, APNG, CUR and more.",
    tools:{
      convert:[
        {name:"JXR to JPG", badge:"HDR → JPG", href:"JXR to JPG.html"},
        {name:"JXR to PNG", badge:"HDR → PNG", href:"JXR to PNG.html"},
        {name:"JXR to HEIC", badge:"HDR → HEIC", href:"JXR to HEIC.html"},
        {name:"PNG to APNG", badge:"Animated PNG", href:"PNG to APNG.html"},
        {name:"PNG to CUR", badge:"Windows cursor", href:"PNG to CUR.html"},
        {name:"PSD to XCF", badge:"Photoshop → GIMP", href:"PSD to XCF.html"},
        {name:"P7S to JPG", badge:"Extract image", href:"P7S to JPG.html"}
      ],
      compress:[],
      edit:[]
    }
  }
];
export default CATEGORIES;
